import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';
import { VehicleOnboardingModel } from 'app/models/registration-vehicles/vehicle-upgrades/vehicle-onboarding-model';
import { UpdateRiderVehicleRequest } from 'app/models/rider/update-rider-vehicle-request.interface';

@Injectable()
export class RiderService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getRiders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressRider/GetRiders', data, messageService);
    }

    public getRidersCoordinates(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRidersCoordinates', data, messageService);
    }

    public getHeatmapPoints(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressRider/GetHeatmapPoints', data, messageService);
    }

    public getHeatmapCitiesCatalog(messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressRider/GetHeatmapCitiesCatalog', {}, messageService);
    }

    public getSurgeFactor(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressRider/GetSurgeFactor', data, messageService);
    }

    public clearHeatmapCache(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressRider/ClearHeatmapCache', data, messageService);
    }

    public getRiderVerificationCheckLists(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiderVerificationCheckLists', data, messageService);
    }

    public addOrUpdateRiderVerificationCheckList(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/AddOrUpdateRiderVerificationCheckList', data, messageService);
    }

    public getAdminRiders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiders', data, messageService);
    }

    public saveRiderRejectReason(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/SaveRiderRejectReason', data, messageService);
    }

    public getDisciplinaryUsers(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetDisciplinaryRiders', data, messageService);
    }

    public getRiderInfo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiderInfo', data, messageService);
    }

    public getRiderShiftLogs(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiderShiftLogs', data, messageService);
    }

    public endRiderShift(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/EndRiderShift', data, messageService);
    }

    public getUnsyncedOrders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDeliveryOrder/GetUnsyncedOrders', data, messageService);
    }

    public syncOfflineOrderFailure(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDeliveryOrder/SyncOfflineSyncFailure', data, messageService);
    }

    public syncOfflineOrderFailuresByRider(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDeliveryOrder/SyncOfflineSyncFailuresByRider', data, messageService);
    }

    public sendUpdatePush(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/SendUpdatePush', data, messageService);
    }

    public getRiderVehicles(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiderVehicles', data, messageService);
    }

    public updateRiderVehicle(data: UpdateRiderVehicleRequest, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/UpdateRiderVehicle', data, messageService);
    }

    public getTrainingCentersRider(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetTrainingCentersRider', data, messageService);
    }

    public addOrUpdateScheduleTraining(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/AddOrUpdateScheduleTraining', data, messageService);
    }

    public getVehicleRidersOnboarding(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetVehicleRidersOnboarding', data, messageService);
    }

    public getOperatorVehicles(data: VehicleOnboardingModel | null, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/GetAllOperatorVehicles', data, messageService);
    }

    public getOperatorVehicleDetail(payload: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressOperator/GetOperatorVehicle', payload, messageService);
    }

    public getRiderVehicleInfo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiderVehicleInfo', data, messageService);
    }

    public saveRiderVehicleReject(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/SaveRiderVehicleReject', data, messageService);
    }

    public changeRiderVehicleStatus(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/ChangeRiderVehicleStatus', data, messageService);
    }

    public getRiderTransactions(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiderTransactions', data, messageService);
    }

    public getRiderStatistics(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiderStatistics', data, messageService);
    }

    public updateTASNumber(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/UpdateTASNumber', data, messageService);
    }

    public activateRider(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/ActivateRider', data, messageService);
    }

    public updateRiderInfo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/UpdateRiderInfo', data, messageService);
    }

    public getRiderDetailsEditLock(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiderDetailsEditLock', data, messageService);
    }

    public updateRiderDetailsEditLock(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/UpdateRiderDetailsEditLock', data, messageService);
    }

    public removeRiderDetailsEditLock(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/RemoveRiderDetailsEditLock', data, messageService);
    }

    public updateRiderInfoV2(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/UpdateRiderInfoV2', data, messageService);
    }

    public searchRiders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/SearchRiders', data, messageService);
    }

    public searchOperatorRiders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/SearchOperatorRiders', data, messageService);
    }

    public getRiderInvoices(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiderInvoices', data, messageService);
    }

    public getRiderInvoice(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiderInvoice', data, messageService);
    }

    public getRiderTripInfo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiderTripInfo', data, messageService);
    }

    public getDraftRiders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetDraftRiders', data, messageService);
    }

    public createDriverByRiderType(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminXpressRider/CreateDriverByRiderType', data, messageService);
    }

    public createDriverApplication(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/CreateDriverApplication', data, messageService);
    }

    public getContentTypeByImageUrl(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetContentTypeByImageUrl', data, messageService);
    }

    public uploadImage(data: FormData, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Image/UploadImage', data, messageService);
    }

    public deleteImage(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Image/DeleteImage', data, messageService);
    }

    public updateDocumentExpiryDates(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Image/UpdateDocumentExpiryDates', data, messageService);
    }

    public updateLegalDocuments(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/UpdateLegalDocuments', data, messageService);
    }

    public getRegistrationRidersV2(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRegistrationRidersV2', data, messageService);
    }

    public getCompaignRiders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetCompaignRiders', data, messageService);
    }

    public setAssignedRiderToSubCampaign(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/SetAssignedRiderToSubCampaign', data, messageService);
    }

    public exportCompaignRiders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/AdminXpressRider/ExportCompaignRiders', data, messageService);
    }

    public getHistoryRiderAvailabilities(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetHistoryRiderAvailabilities', data, messageService);
    }

    public getRiderApplicationDetails(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiderApplicationDetails', data, messageService);
    }

    public setDocumentVerificationStatus(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/SetDocumentVerificationStatus', data, messageService);
    }

    public updateRiderApplicationDetails(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/UpdateRiderApplicationDetails', data, messageService);
    }

    public exportRiderAppHistory(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/AdminXpressRider/ExportRiderAppHistory', data, messageService);
    }

    public getCompaignXpress50Riders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetCompaignXpress50Riders', data, messageService);
    }

    public exportActiveRiders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/AdminXpressRider/ExportActiveRiders', data, messageService);
    }

    public addOrRemoveRiderCampaign(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/AddOrRemoveRiderCampaign', data, messageService);
    }

    public getRidersForApplicationAudit(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRidersForApplicationAudit', data, messageService);
    }

    public getCounterByApplicationRegistration(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetCounterByApplicationRegistration', data, messageService);
    }

    public getXpress50Riders4wForReward(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetXpress50Riders4wForReward', data, messageService);
    }

    public removeRiderOperatorMapping(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/RemoveRiderOperatorMapping', data, messageService);
    }

    public uploadInvitedRiders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/UploadInvitedRiders', data, messageService);
    }

    public validateInvitePhone(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/ValidateInvitePhone', data, messageService);
    }

    public sendSingleInvite(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/SendSingleInvite', data, messageService);
    }

    public resendInvitedRider(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/ResendInvitedRider', data, messageService);
    }

    public overrideInvitedRiders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/OverrideInvitedRiders', data, messageService);
    }

    public downloadExistingRiders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/AdminXpressRider/DownloadExistingRiders', data, messageService);
    }

    public getLastRiderLocation(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetLastRiderLocation', data, messageService);
    }

    public getRidersByVehicle(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRidersByVehicle', data, messageService);
    }

    public addRidersToOperatorVehicle(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/AddRidersToOperatorVehicle', data, messageService);
    }

    public removeRiderFromOperatorVehicle(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/RemoveRiderFromOperatorVehicle', data, messageService);
    }

    public getActiveRidersCoordinates(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetActiveRidersCoordinates', data, messageService);
    }

    public getRiderLocationHistory(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/GetRiderLocationHistory', data, messageService);
    }

    public setRiderStatus(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressRider/SetRiderStatus', data, messageService);
	}

	public getTaxiVehicles(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminXpressRider/GetTaxiVehicles', data, messageService);
	}

	public createTaxiVehicle(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminXpressRider/CreateTaxiVehicle', data, messageService);
	}

	public updateTaxiVehicle(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminXpressRider/UpdateTaxiVehicle', data, messageService);
	}

	public assignVehicleToRider(data: { VehicleId: number; DriverId: number | null }, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminXpressRider/AssignVehicleToRider', data, messageService);
	}

	public setDriverVehicleAvailability(
		data: { RiderId: number; VehicleId: number; IsActive: boolean },
		messageService: MessageService
	): Promise<any> {
		return this.apiHttp.post('api/AdminXpressRider/SetDriverVehicleAvailability', data, messageService);
	}

	public getRiderCompensationProfile(data: { RiderId: number; ServiceTypeId: number }, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminRiderCompensationProfile/GetRiderCompensationProfile', data, messageService);
	}

	public updateRiderEarningType(data: { RiderId: number; IsSalaried: boolean }, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminXpressRider/UpdateRiderEarningType', data, messageService);
	}

	public requestSendLogs(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminXpressRider/RequestSendLogs', data, messageService);
	}

	public getSendLogRequests(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminXpressRider/GetSendLogRequests', data, messageService);
	}
}
